// src/components/MetricCard.js

import React from 'react';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

// This component is now aware of a "neutral" state
function ChangeIndicator({ change, className = '' }) {
  if (change === null || isNaN(change)) {
    return null;
  }

  const isNeutral = className.includes('neutral');
  const isPositive = change >= 0;
  const changePercentage = (Math.abs(change) * 100).toFixed(1);

  // Determine the CSS class for coloring (positive, negative, or neutral)
  const colorClass = isNeutral ? 'neutral' : (isPositive ? 'positive' : 'negative');
  const containerClasses = `change-indicator ${colorClass}`;

  return (
    <span className={containerClasses}>
      {/* Only show sign if NOT neutral */}
      {!isNeutral && (isPositive ? '+' : '-')}
      
      {changePercentage}%
      
      {/* Only show arrow if NOT neutral */}
      {!isNeutral && (
        isPositive ? (
          <ArrowUpRight className="change-icon" />
        ) : (
          <ArrowDownRight className="change-icon" />
        )
      )}
    </span>
  );
}

export default function MetricCard({ title, value, change = null, isCurrency = true, className = '', ...rest }) {
  const formattedValue = isCurrency
    ? `$${(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : value;

  return (
    <div className={`metric-card ${className}`} {...rest}>
      <h2 className="metric-card-title">{title}</h2>
      <div className="metric-card-value-container">
        <span className="metric-card-value">{formattedValue}</span>
        <ChangeIndicator change={change} className={className} />
      </div>
      {change !== null && (
        <div className="metric-card-comparison-text">
          of Gross Income
        </div>
      )}
    </div>
  );
}
